import { render, staticRenderFns } from "./ProductStock.vue?vue&type=template&id=e547a640&scoped=true"
import script from "./ProductStock.vue?vue&type=script&lang=js"
export * from "./ProductStock.vue?vue&type=script&lang=js"
import style0 from "./ProductStock.vue?vue&type=style&index=0&id=e547a640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e547a640",
  null
  
)

export default component.exports